(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-about-page-builder"]) return;
  try {
    

$(function() {

function doCarousel() {
  $('.stylists').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


  jQuery(document).on('shopify:section:load', function(){
    doCarousel()
  })

  $('.stylists').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-careers-page-builder"]) return;
  try {
    
$(function() {

function doCarousel() {
  $('.stylists').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


$(document).on('shopify:section:load', function(){
  doCarousel();
});

$('.stylists').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq-page-builder"]) return;
  try {
    
$(function() {

function doCarousel() {
  $('.stylists').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


$(document).on('shopify:section:load', function(){
  doCarousel();
});

$('.stylists').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-featured-blocks"] && !window.DesignMode) return;
  try {
    
$(function() {

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-hero"] && !window.DesignMode) return;
  try {
    

function doCarousel() {
  $('.home-hero-js').slick({
    autoplay: true,
    dots: true,
    infinite: true,
    autoplaySpeed: '7000',
    speed: '900',
    fade: true
  });
}

jQuery(document).on('shopify:section:load', function(){
  doCarousel()
})


$(function() {
  $('.home-hero-js').slick({
    autoplay: true,
    dots: true,
    infinite: true,
    autoplaySpeed: '7000',
    speed: '900',
    fade: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-services-page-builder"]) return;
  try {
    
$(function() {

function doCarousel() {
  $('.stylists').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


$(document).on('shopify:section:load', function(){
  doCarousel();
});

$('.stylists').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



});

  } catch(e) { console.error(e); }
})();
})();
